document.addEventListener("DOMContentLoaded", function () {
  var policyContainer = document.querySelector(".shopify-policy__container");
  
  if (policyContainer) {
    policyContainer.classList.add("page-width");
  }


  const interval = setInterval(() => {
  const el = document.getElementById('wishlist-hero-shared-list-view');

  if (el) {
    el.classList.add('page-width');
    clearInterval(interval);
  }
}, 300); // check every 300ms


});

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const nameInputs = document.querySelectorAll('.name-field input');

    if (nameInputs.length > 0) {

      nameInputs.forEach(function (input) {
        // On every change, clean the value
        input.addEventListener('input', function () {
          this.value = this.value.replace(/[^a-zA-Z]/g, '');
        });

        // Also block pasting invalid characters
        input.addEventListener('paste', function (e) {
          const paste = (e.clipboardData || window.clipboardData).getData('text');
          if (!/^[a-zA-Z]+$/.test(paste)) {
            e.preventDefault();
          }
        });
      });
    }
  }, 1000); // delay in milliseconds
});



